import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';
import clsx from 'clsx';
import { textOverflowMui } from 'constants/textOverflowMui';

import styles from 'components/_basic/Form/FieldTable2/components/FieldTableHeader/FieldTableHeader.module.scss';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { TooltipComponent } from 'components/_basic/TooltipComponent';
import { TOOLTIP_VARIANT } from 'components/_basic/TooltipComponent/constants';

import { concatWithDot } from 'helpers/string';

interface ITableHeaderProps {
  columnsNames: string[];
  disabled: boolean;
  name: string;
  firstColumnWidth: number;
  lastColumnWidth: number;
  inputMaxLength?: number;
}

export const TableColumns: FC<ITableHeaderProps> = ({
  columnsNames,
  disabled,
  name,
  firstColumnWidth,
  lastColumnWidth,
  inputMaxLength,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Grid container spacing={0} sx={{ marginBottom: '12px' }} wrap="nowrap">
      <Grid item width={firstColumnWidth} marginRight={1} />
      <Grid item xs>
        <Grid container spacing={1} columns={columnsNames.length} wrap="nowrap">
          {columnsNames.map((item) => {
            const inputName = concatWithDot(name, item);
            return (
              <Grid item xs={1} key={item}>
                <TooltipComponent title={t('rename')} variant={TOOLTIP_VARIANT.SMALL}>
                  <Box>
                    <TextInputControl
                      control={control}
                      id={inputName}
                      name={inputName}
                      className={clsx(styles.textInput)}
                      disabled={disabled}
                      variant="standard"
                      hiddenLabel
                      maxLength={inputMaxLength}
                      sx={{
                        '&.MuiFormControl-root ': {
                          height: '100%',
                        },
                        '& .MuiInput-input': {
                          marginLeft: '0 !important',
                          padding: '3px !important',
                        },
                        '& .MuiInputBase-input': {
                          marginLeft: 0,
                        },
                      }}
                      InputProps={{
                        sx: {
                          height: '100%',
                          minHeight: '100%',
                          alignItems: 'stretch',
                          display: 'flex',
                          marginLeft: 0,
                        },
                      }}
                      inputProps={{
                        sx: textOverflowMui,
                      }}
                    />
                  </Box>
                </TooltipComponent>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid item width={lastColumnWidth} />
    </Grid>
  );
};
